import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {getClientMetrics} from '/redux/action/metric.action';
import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  allCandidatesCountById,
  hasClientMetricsById,
  referralsCountById,
} from '/redux/selector/metric.clients.selector';
import {generateCallback} from '/util/component.util';
import {withProps} from '/util/selector.util';

import Clients from './Clients';

const withCoachUserId = withProps({coachId: userId});
export default connect(
  createStructuredSelector({
    hasClientMetricsById: withProps({coachId: userId})(hasClientMetricsById),
    allCandidatesCount: withCoachUserId(allCandidatesCountById),
    referralsCount: withCoachUserId(referralsCountById),
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestRankDescription: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
    coachCurrentRank: withProps({coachId: userId})(rankDescriptionById),
  }),
  dispatch => ({
    getClientMetrics: generateCallback({
      func: dispatch,
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      params: getClientMetrics(),
    }),
  }),
)(Clients);
